module.exports = __webpack_public_path__ + "img/16.ef805f07.png";